import React, { useEffect, useContext } from 'react'
import { useLazyQuery } from '@apollo/client'
import { DailyMonitoringDetailsFiltersContext } from '../../../../../context/DailyMonitoringDetailsFiltersContext'
import { GET_ORDERS_OPEN_GMV_QUANTITY_HISTORY } from '../../../../../queries/dailyMonitoring'
import { defaultFormatMonthTimeZone } from '../../../../../utils/consts'
import DailyOrderOpenGMVQuantity from './DailyOrderOpenGMVQuantity'
import DailyOrderOpenGMVTotal from './DailyOrderOpenGMVTotal'

export default function DailyOrderOpenGMV (): JSX.Element {
  const { filters } = useContext(DailyMonitoringDetailsFiltersContext)
  const [getData, { loading, error, data }] = useLazyQuery(
    GET_ORDERS_OPEN_GMV_QUANTITY_HISTORY,
    {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    const createdAt: any = {
      initialDate: `${filters.date.year}-${filters.date.month}||/M`,
      finalDate: `${filters.date.year}-${filters.date.month}||/M`,
      ...defaultFormatMonthTimeZone
    }

    getData({
      variables: { filters: { states: filters.states, cities: filters.cities, createdAt } }
    })
  }, [filters])

  return (
    <>
      <DailyOrderOpenGMVTotal data={data} filters={filters} loading={loading} error={error} />
      <DailyOrderOpenGMVQuantity data={data} filters={filters} loading={loading} error={error} />
    </>
  )
}
